export const CONTACT = {
  EMAIL_SUPPORT: 'hola@tryquipus.com',
  EMAIL_PRIVACY: 'hola@tryquipus.com',
  WA_NUMBER:     '19089639982',
  WA_URL:        'https://wa.me/19089639982',
} as const;

export const URLS = {
  APP:         'https://app.tryquipus.com',
  MARKETING:   'https://tryquipus.com',
  VERIFY:      'https://tryquipus.com/verify',
  DASHBOARD:   'https://app.tryquipus.com/dashboard',
  SECURITY:    'https://app.tryquipus.com/settings/security',
  UNSUBSCRIBE: 'https://app.tryquipus.com/unsubscribe',
  PRIVACY:     'https://app.tryquipus.com/privacy',
} as const;

export const AI_LIMITS = {
  BETA_DAILY:    20,
  STARTER_DAILY: 50,
} as const;

// Límite de empresas activas por plan de suscripción.
// null = sin límite (enterprise).
export const PLAN_COMPANY_LIMITS: Record<string, number | null> = {
  trial:       1,
  educativo:   1,
  emprendedor: 1,
  starter:     5,
  pro:         15,
  firma:       30,
  enterprise:  null,
};

// Límite de asistentes (team_members) por plan de suscripción.
// 0 = plan no incluye asistentes (ocultar UI de invitación).
// null = sin límite (enterprise).
// trial: 1 para que puedan probar la funcionalidad.
export const ASSISTANT_LIMITS: Record<string, number | null> = {
  trial:       1,
  educativo:   1,
  emprendedor: 0,
  starter:     0,
  pro:         3,
  firma:       10,
  enterprise:  null,
};

export const PLAN_LABELS: Record<string, string> = {
  educativo:   'Educativo',
  emprendedor: 'Emprendedor',
  starter:     'Contador',
  pro:         'Profesional',
  firma:       'Firma',
  enterprise:  'Enterprise',
};

export const REGIMEN_LABELS: Record<string, string> = {
  general: 'Régimen General',
  mype:    'MYPE Tributario',
  rer:     'RER',
  nrus:    'NRUS',
};

export const REGIMEN_COLORS: Record<string, string> = {
  general: '#38bdf8',
  mype:    '#a78bfa',
  rer:     '#fbbf24',
  nrus:    '#34d399',
};

// Semantic accent colors for financial sections
// CxP (Cuentas por Pagar / gastos / pagos outbound) → cyan brand
// CxC (Cuentas por Cobrar / ingresos / cobros inbound) → emerald
export const ACCENT_CXP = '#38bdf8'; // cyan — pagos
export const ACCENT_CXC = '#10b981'; // emerald — cobros
